import { LOCALSTORAGE_CACHE_KEY } from 'config/localStorage';
import { removeToken } from './localStorage';

export const logoutUser = () => {
  removeToken();
  localStorage.removeItem(LOCALSTORAGE_CACHE_KEY);
  window.location.href = '/login';
};
